import { ReactNode } from 'react'
import { ScrollView, StyleSheet, Text } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import { LinearGradient } from 'expo-linear-gradient'

const gradientStart = { x: 0, y: 0 }
const gradientEnd = { x: 0, y: 1 }

const UserFlowPage = ({
  eyebrow,
  title,
  description,
  children,
}: {
  eyebrow?: string
  title: string
  description: string
  children: ReactNode
}) => {
  return (
    <ScrollView
      className="flex-1 bg-white"
      contentContainerStyle={styles.pageContainer}
    >
      <LinearGradient
        colors={['#EFFAD9', '#FFFFFF']}
        start={gradientStart}
        end={gradientEnd}
      >
        <Stack className="overflow-hidden px-4 pb-8 pt-6">
          <Stack className="rounded-md bg-[#7E2BC0] px-2 py-1 self-start">
            <Text style={styles.zetBadgeText}>ZET</Text>
          </Stack>
          {eyebrow ? <Text style={styles.eyebrowText}>{eyebrow}</Text> : null}
          <Text style={styles.pageTitle}>{title}</Text>
          <Text style={styles.pageDescription}>{description}</Text>
        </Stack>
      </LinearGradient>
      <Stack className="flex-1 bg-white px-4 pb-10 pt-4">{children}</Stack>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  eyebrowText: {
    marginBottom: 12,
    marginTop: 32,
    fontFamily: 'THICCCBOI-Medium',
    fontSize: 12,
    lineHeight: 18,
    letterSpacing: 2,
    color: '#8CC350',
    textTransform: 'uppercase',
  },
  pageContainer: {
    flexGrow: 1,
  },
  pageDescription: {
    marginTop: 4,
    maxWidth: 320,
    fontFamily: 'THICCCBOI-Medium',
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: -0.32,
    color: '#8CC350',
  },
  pageTitle: {
    maxWidth: 280,
    fontFamily: 'THICCCBOI-ExtraBold',
    fontSize: 22,
    lineHeight: 32,
    letterSpacing: -0.44,
    color: '#341B45',
  },
  zetBadgeText: {
    fontFamily: 'THICCCBOI-SemiBold',
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: -0.28,
    color: '#FFFFFF',
  },
})

export default UserFlowPage
